import React from 'react';
import IndustryContainer from '../../../Containers/AdminContainer/Industry';
const IndustryScreen = () => {
  return <IndustryContainer />;
};

export default IndustryScreen;
